/* global $:false */

/*
 * decaffeinate suggestions:
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export default class AccountIdentity {
  static init () {
    Array.from($('.js-account-identity')).map((el) =>
      new AccountIdentity(el))
  }

  constructor (el) {
    this.showBirthdayField = this.showBirthdayField.bind(this)
    this.showIdentifierFiField = this.showIdentifierFiField.bind(this)
    this.showIdentifierSeField = this.showIdentifierSeField.bind(this)
    this.el = $(el)
    this.findElements()
    this.setupBindings()
  }

  findElements () {
    this.countrySelect = this.el.find('.js-account-identity__country-select')
    this.birthdayWrapper = this.el.find('.js-account-identity__birthday-wrapper')
    this.birthdayField = this.el.find('.js-account-identity__birthday')
    this.identifierFiWrapper = this.el.find('.js-account-identity__identifier_fi-wrapper')
    this.identifierFiField = this.el.find('.js-account-identity__identifier_fi')
    this.identifierSeWrapper = this.el.find('.js-account-identity__identifier_se-wrapper')
    this.identifierSeField = this.el.find('.js-account-identity__identifier_se')
  }

  setupBindings () {
    this.countrySelect.change(event => {
      let needle, needle1
      if ((needle = $(event.target).val(), ['FI'].includes(needle))) {
        this.showIdentifierFiField()
      } else if ((needle1 = $(event.target).val(), ['SE'].includes(needle1))) {
        this.showIdentifierSeField()
      } else {
        this.showBirthdayField()
      }
    })
  }

  showBirthdayField () {
    this.identifierSeWrapper.hide()
    this.identifierSeField.attr('disabled', true)
    this.identifierFiWrapper.hide()
    this.identifierFiField.attr('disabled', true)
    this.birthdayWrapper.show()
    this.birthdayField.attr('disabled', false)
  }

  showIdentifierFiField () {
    this.birthdayWrapper.hide()
    this.birthdayField.attr('disabled', true)
    this.identifierSeWrapper.hide()
    this.identifierSeField.attr('disabled', true)
    this.identifierFiWrapper.show()
    this.identifierFiField.attr('disabled', false)
  }

  showIdentifierSeField () {
    this.birthdayWrapper.hide()
    this.birthdayField.attr('disabled', true)
    this.identifierFiWrapper.hide()
    this.identifierFiField.attr('disabled', true)
    this.identifierSeWrapper.show()
    this.identifierSeField.attr('disabled', false)
  }
}
